import get from 'lodash/get';

export const mapFormToOnboardingTemplate = (values, communityId) => ({
  name: values.name,
  tag: values.tag,
  communityId,
  isInternal: !values.isInternal,
  appSuggestions: (values.apps || []).map(app => ({
    installationTag: get(app.appInstallation.split('_'), '[1]'),
    featureSuggestions: (app.features || [])
      .map(f => ({
        featureTag: f.feature,
        roleSuggestions: f.roles,
      }))
      .filter(feature => feature.roleSuggestions?.length > 0),
  })),
  communityRoleSuggestions: values.communityRoles || [],
  version: values.version,
});
